import { render, staticRenderFns } from "./ClientsDropDown.vue?vue&type=template&id=a82fb9f0"
import script from "./ClientsDropDown.vue?vue&type=script&lang=js"
export * from "./ClientsDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports